export default function (element, data) {
    window.addEventListener("open-popup-oils", function (e) {
        element.classList.add("open");
        document.body.classList.add('no-scroll');
    });
    window.addEventListener("close-popup-oils", function () {
        element.classList.remove("open");
        document.body.classList.remove('no-scroll');
    });
    element.addEventListener("click", function (event) {
        window.dispatchEvent(new CustomEvent('close-popup-oils'));
    });
    element.querySelector(".grass__popup_block").addEventListener("click", function (event) {
        event.stopPropagation();
    });
}
